<template>
    <div>
        <div class="full-content" style="background-image:url('assets/img/bg-gaspol-1.jpg');">
            <div class="card bg-card-trans border-0 rounded-0 mobile-ver">
                <div v-if="dataFetch">
                    <p class="text-center mt-5">Loading...</p>
                </div>

                <div v-if="!dataFetch">
                    <div class="mobile-ver-top mobile-ver-top-2">
                        <div class="d-flex align-items-center h-100 justify-content-between px-3">
                            <div class="d-flex align-items-center">
                                <a href="javascript:void(0)" class="btn btn-white-naked btn-icon me-md-3 me-2" v-on:click="goToPage('student_rapor')">
                                    <i class="fa-solid fa-arrow-left"></i>
                                </a>
                                <div class="d-block display-tektur h1 m-0">Atur Pilihan</div>
                            </div>
                        </div>
                    </div>
                    <div class="mobile-ver-content--has-simplebar mobile-ver-content-2 full-bottom">
                        <div class="d-block px-md-4 px-3">
                            <div class="d-block pt-3">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="d-flex align-items-center justify-content-between mb-4">
                                            <div class="d-block h3 m-0">Pilih Tahun Lulus</div>
                                        </div>

                                        <div class="card border m-0">
                                            <div class="d-block p-3 text-center">
                                                <select class="form-select form-select-box-1" v-model="form.graduation_year" required oninvalid="this.setCustomValidity('Pilih Tahun Lulus')" oninput="this.setCustomValidity('')">
                                                    <option value="">Pilih Tahun Lulus</option>
                                                    <option v-for="(item, index) in dataYear" :key="index" :value="item.id">{{ item.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-body">
                                        <div class="d-flex align-items-center justify-content-between mb-4">
                                            <div class="d-block h3 m-0"><span
                                                    class="display-tektur text-pink me-3">01</span>Pilihan Pertama</div>
                                            <button v-if="dataRationalization.users.allow_change_major == 1" type="button" data-bs-toggle="modal" data-bs-target="#cariJurusan"
                                                class="btn btn-sm btn-s-1 btn-white" v-on:click="chooseActive('1')">
                                                <div class="btn-s-1-inner"><i class="fa-solid fa-magnifying-glass me-2"></i>Cari Jurusan</div>
                                            </button>
                                        </div>

                                        <div class="card bg-dblue border m-0" v-if="form.major_one.major_fullname">
                                            <div class="d-block p-3 text-center">
                                                <div class="d-block mb-2 text-sm">{{form.major_one.major_fullname}}</div>
                                                <div class="d-block display-tektur m-0 text-pink text-sm">{{ form.university_one.name }}</div>
                                            </div>
                                        </div>

                                        <div class="card bg-dblue border m-0" v-if="!form.major_one.major_fullname">
                                            <div class="d-block p-3 text-center">
                                                <div class="d-block mb-2 text-pink"><i class="fa-solid fa-triangle-exclamation fa-lg"></i></div>
                                                <div class="d-block text-sm ">Kamu belum menentukan jurusan.</div>
                                            </div>
                                        </div>
                                        
                                        <div v-if="dataRationalization.users.allow_change_major == 1" class="d-block pt-4 text-muted small border-top mt-4">
                                            Kamu dapat memilih jurusan dengan menekan tombol "Cari Jurusan" lalu klik tombol "Pilih" untuk memilih jurusan yang sesuai.
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-body">
                                        <div class="d-flex align-items-center justify-content-between mb-4">
                                            <div class="d-block h3 m-0"><span
                                                    class="display-tektur text-pink me-3">02</span>Pilihan Kedua</div>
                                            <button v-if="dataRationalization.users.allow_change_major == 1" type="button" data-bs-toggle="modal" data-bs-target="#cariJurusan"
                                                class="btn btn-sm btn-s-1 btn-white" v-on:click="chooseActive('2')">
                                                <div class="btn-s-1-inner"><i class="fa-solid fa-magnifying-glass me-2"></i>Cari
                                                    Jurusan</div>
                                            </button>
                                        </div>
                                        <div class="card bg-dblue border m-0" v-if="form.major_two.major_fullname">
                                            <div class="d-block p-3 text-center">
                                                <div class="d-block mb-2 text-sm">{{form.major_two.major_fullname}}</div>
                                                <div class="d-block display-tektur m-0 text-pink text-sm">{{ form.university_two.name }}</div>
                                            </div>
                                        </div>

                                        <div class="card bg-dblue border m-0" v-if="!form.major_two.major_fullname">
                                            <div class="d-block p-3 text-center">
                                                <div class="d-block mb-2 text-pink"><i class="fa-solid fa-triangle-exclamation fa-lg"></i></div>
                                                <div class="d-block text-sm ">Kamu belum menentukan jurusan.</div>
                                            </div>
                                        </div>
                                        <div v-if="dataRationalization.users.allow_change_major == 1" class="d-block pt-4 text-muted small border-top mt-4">
                                            Kamu dapat memilih jurusan dengan menekan tombol "Cari Jurusan" lalu klik tombol "Pilih" untuk memilih jurusan yang sesuai.
                                        </div>
                                    </div>
                                </div>
                                <div v-if="dataRationalization.users.account_type == 'free'" class="d-none pt-4 text-muted small border-top mt-4 mb-4 text-center">
                                    Kamu <b>hanya dapat memilih jurusan 1x</b> karena terdaftar sebagai akun gratis.
                                </div>
                                <div class="d-flex justify-content-end pe-2 mb-4" v-if="(form.major_one.name || form.major_two) && dataRationalization.users.allow_change_major == 1">
                                    <button type="button" class="btn btn-s-1 btn-primary px-4" v-on:click="saveChooice">
                                        <div class="btn-s-1-inner">Simpan Pilihan</div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" id="cariJurusan" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content overflow-hidden">
                    <div class="modal-body">
                        <div class="row align-items-center mb-4">
                            <div class="col">
                                <div class="h1 m-0 display-tektur">
                                    Cari Jurusan - <span class="text-pink">Pilihan {{ choose_active == 1 ? 'Pertama':'Kedua' }}</span>
                                </div>
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-white-naked btn-icon" data-bs-dismiss="modal" aria-label="Close" id="close-modal">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                        <div class="d-block">
                            <div class="input-icon">
                                <input class="form-control m-0" type="text" placeholder="Cari jurusan disini..." v-model="keywords" v-on:keyup.enter="loadKeywords">
                                <i class="fa-solid fa-magnifying-glass text-muted"></i>
                            </div>
                        </div>
                    </div>
                    <div class="d-block border-top">
                        <div data-simplebar class="d-block" style="max-height:68vh;overflow-y:auto;">
                            <table class="table border-0 m-0">
                                <tbody>
                                    <tr v-for="(item, index) in dataMajor" :key="index">
                                        <td class="w-100 td-wrap ps-4">
                                            <div class="show-767 text-sm text-neon mb-2">{{ item.major_code }}</div>
                                            <div class="d-block">{{ item.major_fullname }}</div>
                                            <div class="d-block text-sm">{{ item.university_name}}</div>
                                        </td>
                                        <td class="text-end hide-767"><div class="d-block text-sm text-neon px-4">{{item.major_code}}</div></td>
                                        <td class="pe-4">
                                            <button type="button" class="btn btn-white" v-on:click="chooseMajor(item)">Pilih</button>
                                        </td>
                                    </tr>
                                    <tr v-if="fetch_major">
                                        <td colspan="3" class="text-center">Loading...</td>
                                    </tr>
                                    <tr v-if="(!fetch_major && !hide_show_more)">
                                        <td colspan="3" class="text-center"><a href="javascript:void(0)" class="text-white" v-on:click="loadMore">Muat lebih banyak</a></td>
                                    </tr>
                                    <tr v-if="(!fetch_major && dataMajor.length < 1)">
                                        <td colspan="3" class="text-center">Data tidak tersedia</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StudentSettingsMajor',
    metaInfo: {
        title: 'Atur Pilihan',
        titleTemplate: '%s - Rasionalisasi Rapor'
    },
    data() {
        return {
            emptyState          : false,
            dataFetch           : false,
            dataRationalization : [],
            dataMajor           : [],
            dataYear            : [],
            choose_active       : '',
            form : {
                id : '',
                graduation_year : '',
                university_one : {
                    id : '',
                    name : ''
                },
                major_one : {
                    id : '',
                    name : '',
                    major_fullname : ''
                },
                university_two : {
                    id : '',
                    name : ''
                },
                major_two : {
                    id : '',
                    name : '',
                    major_fullname : ''
                }
            },
            keywords : '',
            fetch_major : false,
            itemsPerPage: 50,
            currentPage: 1,
            hide_show_more : false
        }
    },
    created() {
        this.getData();
        this.getMajor();
        this.getYear();
    },
    methods: {
        goToPage: function (params = null) {
            this.$router.push({
                name: params
            })
        },
        getYear: function() {
            let uri         = process.env.VUE_APP_APIHOST+'year/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataYear = res.data.data;
            });
        },
        chooseActive: function(params=null) {
            this.choose_active = params
        },     
        getData: function() {
            let uri         = process.env.VUE_APP_APIHOST+'rationalization/my_rapor';

            this.dataFetch  = true;                
            this.$http.get(uri).then(res => {
                this.dataFetch              = false;
                this.dataRationalization    = res.data.data;
                
                if(this.dataRationalization.id) {
                    this.form.id                = this.dataRationalization.id;
                    this.form.graduation_year   = this.dataRationalization.graduation_year;
                    if(this.dataRationalization.university_one.length != 0) {
                        this.form.university_one    = this.dataRationalization.university_one;
                    }

                    if(this.dataRationalization.major_one != 0) {
                        this.form.major_one         = this.dataRationalization.major_one;
                    }

                    if(this.dataRationalization.university_two != 0) {
                        this.form.university_two    = this.dataRationalization.university_two;
                    }

                    if(this.dataRationalization.major_two != 0) {
                        this.form.major_two         = this.dataRationalization.major_two;
                    }
                }
            });
        },
        loadKeywords: function() {
            this.fetch_major = true;
            this.currentPage = 1;
            this.dataMajor = [];

            let params = new URLSearchParams();
            params.set('page', this.currentPage);
            params.set('limit', this.itemsPerPage);
            params.set('keywords', this.keywords.trim());

            let uri = process.env.VUE_APP_APIHOST + 'major/list-by-pg?' + params.toString();

            this.$http.get(uri).then(res => {
                if (res.data.data.length > 0) {
                    this.dataMajor.push(...res.data.data);
                    this.currentPage++;
                    this.hide_show_more = false;
                } else {
                    this.hide_show_more = true;
                }
                this.fetch_major = false;
            });            
        },
        getMajor: function() {
            this.fetch_major = true;

            if (this.keywords.trim() !== '') {
                this.currentPage = 1;
                this.dataMajor = [];
            }
            
            let params = new URLSearchParams();
            params.set('page', this.currentPage);
            params.set('limit', this.itemsPerPage);
            params.set('keywords', this.keywords.trim());

            let uri = process.env.VUE_APP_APIHOST + 'major/list-by-pg?' + params.toString();

            this.$http.get(uri).then(res => {
                if (res.data.data.length > 0) {
                    this.dataMajor.push(...res.data.data);
                    this.currentPage++;
                    this.hide_show_more = false;
                } else {
                    this.hide_show_more = true;
                }
                this.fetch_major = false;
            });            
        },
        loadMore: function() {
            this.fetch_major = true;
            
            let params = new URLSearchParams();
            params.set('page', this.currentPage);
            params.set('limit', this.itemsPerPage);
            params.set('keywords', this.keywords.trim());

            let uri = process.env.VUE_APP_APIHOST + 'major/list-by-pg?' + params.toString();

            this.$http.get(uri).then(res => {
                if (res.data.data.length > 0) {
                    this.dataMajor.push(...res.data.data);
                    this.currentPage++;
                    this.hide_show_more = false;
                } else {
                    this.hide_show_more = true;
                }
                this.fetch_major = false;
            });            
        },
        chooseMajor: function(item) {
            if(this.choose_active == '1') {
                this.form.university_one.id = item.university_id
                this.form.university_one.name = item.university_name
                this.form.major_one.id  = item.major_id;
                this.form.major_one.name  = item.major_name;
                this.form.major_one.major_fullname  = item.major_fullname;
            }

            if(this.choose_active == '2') {
                this.form.university_two.id = item.university_id
                this.form.university_two.name = item.university_name
                this.form.major_two.id  = item.major_id;
                this.form.major_two.name  = item.major_name;
                this.form.major_two.major_fullname  = item.major_fullname;
            }

            document.getElementById('close-modal').click();
        },
        saveChooice: function() {
            if(this.form.graduation_year == '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Harap pilih tahun lulus!',
                });
            } else {
                this.$swal({
                    icon: 'info',
                    title: 'Konfirmasi',
                    text: 'Apakah data yang kamu pilih sudah sesuai?',
                    confirmButtonText: 'Yakin',
                    showCancelButton: true,
                    cancelButtonText: 'Batal',
                }).then((result) => {
                if (result.value) {
                    this.$http.post(process.env.VUE_APP_APIHOST + 'rationalization/save_chooice', {
                        id              : this.form.id,
                        graduation_year : this.form.graduation_year,
                        university_one  : this.form.university_one.id,
                        major_one       : this.form.major_one.id,
                        university_two  : this.form.university_two.id,
                        major_two       : this.form.major_two.id
                    })
                    .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.goToPage('student_rapor');
                                }
                            });
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: response.data.message,
                            });
                        }
                    })
                }
                });
            }
        }
    }
}
</script>
